import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { NewWorkbookForPublishedConnection } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface NewWorkbookForPublishedConnectionAction extends Action {
  contentInfo: IContentInfo;
}

export function newWorkbookForPublishedConnection(contentInfo: IContentInfo): NewWorkbookForPublishedConnectionAction {
  return {
    type: NewWorkbookForPublishedConnection,
    contentInfo
  };
}

export const isNewWorkbookForPublishedConnectionAction = isActionFactory<NewWorkbookForPublishedConnectionAction>(NewWorkbookForPublishedConnection);
